<template>
  <div class="container lms-wrapper-two">
    
    <student-nav />

    <div class="lms-content buddy-content" @click="closeLevel2()">
      <student-header class="filled" :navbarmode.sync="navbarMode" ref="lmsv4header" />
     
      <div class="lms-content-body" style="height: calc(100vh - 80px)">
        
      
      <vue-custom-scrollbar class="" style="height: calc(100vh - 80px);">
        <div class="container-fluid mg-y-20">
          <div class="d-flex align-items-center mg-b-20">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb breadcrumb-style4 mg-b-10">
                <li class="breadcrumb-item"><router-link :to="{ name: 'buddyAdminDashboard' }" class="tx-11" style="color: #444">Onboarding</router-link></li>
                <li class="breadcrumb-item"><router-link :to="{ name: 'buddyAdminChecklistDashboard' }" class="tx-11" style="color: #444">Checklist</router-link></li>
                <li class="breadcrumb-item"><router-link :to="{ name: 'buddyAdminChecklist1Detail', params: {id: $route.params.code } }" class="tx-11" style="color: #444">{{ getFieldFromConstants('title') }}</router-link></li>
                <li class="breadcrumb-item active tx-14" aria-current="page">{{ depart.depart }}</li>
              </ol>
            </nav>
          </div>
          

          <newbies ref="rfNewbiews" roleProp="button" :filterModelProp="{ departId: $route.params.id }"
          @on-detail="newbieDetail"></newbies>

        </div>

      </vue-custom-scrollbar>
    </div>

      <vue-custom-scrollbar
        class="lms-sidebar-right"
      >
        <div class="lms-sidebar-right-header">
          <div class="pos-absolute r-20 t-20">
            <div :class="`dropdown dropdown-profile`" v-show="$route.name=='buddyParticipant'">
                <a href class="dropdown-link" data-toggle="dropdown">
                  <img :src="`${myResBaseUrl}v4-assets/icon1.png`" />
                </a>
                <div class="divide-y dropdown-menu dropdown-menu-right tx-13">
                  <router-link to="/lms/profile" class="dropdown-item pd-l-0-f mg-b-15" role="button">
                    <feather type="user" class="ht-20-f mg-r-5" style="width: 20px; height: 20px;"></feather
                    >Профайл
                  </router-link>
                  <a @click="logout" class="dropdown-item pd-l-0-f mg-t-0-f" role="button">
                    <feather type="log-out" class="ht-20-f mg-r-5" style="width: 20px; height: 20px;"></feather
                    >Гарах
                  </a>
                </div>
              </div>
          </div>
          <a >
            <part-user-sidebar :mustJoinCourses="mustJoinCourses"></part-user-sidebar>
          </a>
        </div>
        
        <div class="lms-sidebar-right-body">

          <vc-calendar is-expanded title-position="left" color="red" /> 
        </div>

        <div class="lms-sidebar-right-footer">
        </div>
      </vue-custom-scrollbar>
    </div>

    

  </div>
</template>

<script>
import { mapActions } from "vuex";

import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import { request } from "@/api/all";
import { getConfigValueByKey } from "@/libs/util";

import contstants from "@/constants";

export default {
  components: {
    vueCustomScrollbar,
    userCover: () => ({
      component: import("@/views/modules/lms/components/userCover.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentCalendar: () => ({
      component: import("@/views/modules/lms/teacher/components/calendar.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    partUserSidebar: () => ({
      component: import( "@/views/modules/lms/student/parts/userSidebar.vue" ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    newbies: () => ({
      component: import("@/views/modules/lms/student/buddy/components/newbies.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      myResBaseUrl: "https://res.gosmart.mn/",
      navbarMode: 0,
      mustJoinCourses: {
        all: 0,
        finished: 0,
      },
      buddyLevels: contstants.levels,
      depart:{
        depart:null
      }
    };
  },
  // beforeCreate() {
  //   require('@/assets/scss/pages/learning.scss');
  // },
  created() {
    this.fetchResBase();
  },
  mounted() {
    this.init();

    let _obj=this.$store.state.buddy.boxNamesFilter;
    _obj.departId= this.$route.params.id;
    this.$store.dispatch('buddy/handleBoxNames',{
      filter: _obj,
      store: this.$store
    });
  },
  destroyed() {
    //this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    newbieDetail(e){
      // console.log('e',e)
      this.$router.push({
        name: 'buddyAdminChecklist3Employee',
        params:{
          id: e.newbie.id,
          depart: this.$route.params.id,
          code: this.$route.params.code
        }
      });
    },
    getFieldFromConstants(field){
      let rv='';
      if(this.buddyLevels.filter(x=>x.code==this.$route.params.code).length ){
        rv= this.buddyLevels.filter(x=>x.code==this.$route.params.code)[0][field];
      }
      return rv
    },
    logout(){
      this.$refs.lmsv4header.logout();
    },
    fetchResBase() {
      if (
        this.$store.state.app.activeGroup.resBaseUrl != undefined &&
        this.$store.state.app.activeGroup.resBaseUrl != ""
      ) {
        this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
      }
    },
    ...mapActions(["handleAside", "resetResponsiveLayoutConfig", "handleMainLayoutConfig"]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    closeLevel2() {
      if (this.$store.state.app.responsiveLayout.level2.show)
        this.resetResponsiveLayoutConfig(document);
    },
    
    getConfigValueByKey(key) {
      return getConfigValueByKey(this.$store.state.app.groupSettings, key);
    },
    init(reset) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Hr/GetInheritedDepart" },
        params: { id: this.$route.params.id },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if(res!=false){
          this.depart=res.data.depart;
          // console.log('GetInheritedDepart', res.data);
        }
      });
    },
    
  },
};
</script>